import { useMemo, useContext } from 'react';
import ReactEcharts from 'echarts-for-react';
import Head from '@/containers/chart_box/Head';
import Body from '@/containers/chart_box/Body';
import { fmtThousand } from '@/utils/comUtil';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';

// tooltip 回调提升到模块级，保证数据不变时 option 内容可被深度比较命中，
// 避免 ReactEcharts 因为回调引用变化而重复 setOption
const tooltipPosition = (pt) => {
  return [pt[0], '10%'];
};

const tooltipFormatter = (p) => {
  const tip = [];
  if (p && Array.isArray(p)) {
    p.forEach((i) => {
      tip.push(`${i?.seriesName}:${fmtThousand(i?.value)}`);
    });
  }
  let node = '日访问趋势<br/>';
  tip.forEach((i, index) => {
    if (index === 1) {
      node += '<br/>' + i;
    } else {
      node += i;
    }
  });
  return node;
};

const LineDistribution = (props) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const { charts } = themeContext[brandContext];
  const { chartsFontSize, fontFamily } = themeContext.comm;
  const { loading11, data = [], title } = props;

  // 渲染阶段直接计算 option，图表挂载时拿到的就是完整配置，
  // 避免先挂载空 option 再由 effect 补一次而绘制两遍
  const option = useMemo(() => {
    if (!data || data.length === 0) {
      return null;
    }
    const sortedData = [...data].sort((a, b) => {
      const aValueType = a.values?.find(
        (item) => item.valueType === 'SORT',
      )?.value;
      const bValueType = b.values?.find(
        (item) => item.valueType === 'SORT',
      )?.value;

      return Number(aValueType) - Number(bValueType);
    });
    const PVData = sortedData.filter((item) => {
      return item.index === 'PV';
    });
    const UVData = sortedData.filter((item) => {
      return item.index === 'UV';
    });
    const PVDataArr = PVData.map((item) => {
      return [item.values[0].value, item.values[1].value];
    });
    const UVDataArr = UVData.map((item) => {
      return [item.values[0].value, item.values[1].value];
    });

    return {
      legend: {
        data: ['PV', 'UV'],
        left: 'right',
        itemHeight: 5,
        itemWidth: 15,
        zlevel: 1,
      },
      textStyle: {
        fontSize: chartsFontSize.s03,
        fontFamily: fontFamily,
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        position: tooltipPosition,
        textStyle: {
          fontSize: chartsFontSize.s03,
        },
        formatter: tooltipFormatter,
      },
      grid: {
        left: 5,
        right: 5,
        containLabel: true,
      },
      barCategoryGap: '50%',
      xAxis: {
        data: PVDataArr.map(function (item) {
          return item[0];
        }),
        axisLabel: {
          textStyle: {
            color: '#333',
          },
        },
      },
      yAxis: {
        axisLabel: {
          textStyle: {
            color: '#333',
          },
        },
      },
      dataZoom: [
        {
          show: true,
          realtime: true,
          height: 15, //这里可以设置dataZoom的尺寸
          bottom: '10%',
        },
        {
          type: 'inside',
        },
      ],
      color: charts.barColorList,
      series: [
        {
          name: 'PV',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#999999',
          },
          lineStyle: {
            width: 1,
          },
          smooth: true,
          data: PVDataArr.map(function (item) {
            return item[1];
          }),
        },
        {
          name: 'UV',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#2196F3',
          },
          lineStyle: {
            width: 1,
          },
          smooth: true,
          data: UVDataArr.map(function (item) {
            return item[1];
          }),
        },
      ],
    };
  }, [charts.barColorList, chartsFontSize.s03, data, fontFamily]);

  return (
    <>
      <Head boxId={title}></Head>
      <Body bizData={data} loading={loading11}>
        {option && (
          <ReactEcharts
            style={{ width: '100%', height: '100%' }}
            option={option}
            notMerge={true}
            lazyUpdate={true}
          />
        )}
      </Body>
    </>
  );
};
export default LineDistribution;
